import { loadStripe, type Stripe } from '@stripe/stripe-js';

const key = (
  import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY as string | undefined
)?.trim();

let stripePromise: Promise<Stripe | null> | null = null;

export function getStripePublishableKey(): string | undefined {
  return key || undefined;
}

/**
 * Lazily loads Stripe.js. Returns null if VITE_STRIPE_PUBLISHABLE_KEY is unset.
 */
export function getStripe(): Promise<Stripe | null> {
  if (!key) {
    return Promise.resolve(null);
  }
  if (!stripePromise) {
    stripePromise = loadStripe(key).catch((err: unknown) => {
      const msg = err instanceof Error ? err.message : String(err);
      console.warn(
        '[Stripe] Stripe.js did not load (timeout, firewall, or ad blocker blocking js.stripe.com):',
        msg
      );
      return null;
    });
  }
  return stripePromise;
}
